import { IAllNotificationsResponse } from '../../interfaces/notifications.interface'

export interface NotificationsStateModel {
  allNotificationsResponse: IAllNotificationsResponse
}
